import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export type JobStats = {
  submitted_count: number;
  progressing_count: number;
  completed_count: number;
  registered_count: number;
  unsuccessful_count: number;
  success_count: number;
  failed_count: number;
  error_count: number;
  inactive_count: number;
  blocked_count: number;
};

export type TaskStats = {
  avg_encode_time: number;
  avg_wait_time: number;
};

type QueueInfo = {
  queue_url: string;
  messages: string;
};

export type QueueStats = {
  main: QueueInfo;
  backfill: QueueInfo;
  retry: QueueInfo;
};

export type BackendConfiguration = {
  number_of_workers: number;
  delay_between_stitcher_registration_polling: number;
  s3_bucket_region: string;
  s3_move_concurrency: number;
  s3_copy_concurrency: number;
  sqs_visibility_timeout: number;
  sqs_max_receive_count: number;
  transcoder_region: string;
  primary_stitcher_regions: string[];
  secondary_stitcher_regions?: string[] | null;
  primary_media_file_host: string;
  secondary_media_file_host?: string | null;
  output_bucket: string;
  output_prefix: string;
  upload_bucket: string;
  ad_server_api: string;
  job_creation_limiter_period_minutes: number;
  job_creation_limiter_max_submission: number;
  job_creation_limiter_url_comparison_parts: number;
  set_id_field_selector_expr: string;
  set_id_field_value_regex: string;
};

export class Stats {
  static async getQueueStats(): Promise<QueueStats> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/queue/stats`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }

  static async getJobStats(): Promise<JobStats> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/job/stats`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }

  static async getTaskStats(): Promise<TaskStats> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/task/stats`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }

  static async getBackendConfiguration(): Promise<BackendConfiguration> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/configuration`);
    const response = await request(url, { method: "GET" }, true);
    return await response.json();
  }

  // It is important to have the following function as arrow functions.
  // Regular function is losing "this" context when passing the methods as callbacks.
  static purgeMainQueue = async () => {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/queue/purge/main`);
    await request(url, { method: "POST" }, true, "Successfully purged main queue");
  };

  static purgeBackfillQueue = async () => {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/queue/purge/backfill`);
    await request(url, { method: "POST" }, true, "Successfully purged backfill queue");
  };

  static purgeRetryQueue = async () => {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/queue/purge/retry`);
    await request(url, { method: "POST" }, true, "Successfully purged retry queue");
  };
}
